// Initialize using: var scrollEvents = new ScrollEvents();

// Example: <h1 on-visible on-visible-class="some_class" on-visible-offset="-100" on-visible-revert></h1>

// Attribute descriptions:
// on-visible (Element will be registered as one to track. Argument will set an offset to adjust when it appears)
// on-visible-class (What class it will receive when visible. This is in addition to the class that is set when you init the lib)
// on-visible-revert (Remove the classes when the element is no longer visible)

// Broadcasts on-visible and on-visible-revert events for jquery event listeners.

// Options Object
// onVisibleClass: Class to add when the element is visible.
// onVisibleOffsetAttribute: Attribute with the offset to use
// onVisibleSelector: Selector to use when finding elements to become visible on scroll.

function ScrollEvents(opts) {

	var defaults = {
		onVisibleClass: 'visible',
		onVisibleOffsetAttribute: 'on-visible',
		onVisibleSelector: '[on-visible]'
	}

	if (!opts) opts = {};
	opts = $.extend(defaults, opts);

	scrollAwareElements = $(opts.onVisibleSelector);

	var getOffset = function(offset) {
		if (_.includes(offset, '%')) {
			return (parseInt(offset)/100) * windowHeight;
		} else {
			return parseInt(offset);
		}
	}

	$(window).scroll(function() {
		var windowHeight = $(window).height();
		var scrollTop = $(window).scrollTop();
		scrollAwareElements.each(function(index, scrollAwareElement) {
			scrollAwareElement = $(scrollAwareElement);
			var onVisibleOffset = getOffset(scrollAwareElement.attr(opts.onVisibleOffsetAttribute)) || 0;

			var becomesVisible = scrollAwareElement.offset().top - windowHeight + onVisibleOffset + scrollAwareElement.height()/2;

			if (scrollTop > becomesVisible) {
				scrollAwareElement.addClass(opts.onVisibleClass).addClass(scrollAwareElement.attr('on-visible-class'));
				// Broadcast that this has run, so we can have it trigger other code.
				scrollAwareElement.triggerHandler('on-visible');
			} else {
				var onVisibleRevert = scrollAwareElement.attr('on-visible-revert');
				if (!_.isUndefined(onVisibleRevert)) {
					scrollAwareElement.removeClass(opts.onVisibleClass).removeClass(scrollAwareElement.attr('on-visible-class'));
					// Broadcast that this has run, so we can have it trigger other code.
					scrollAwareElement.triggerHandler('on-visible-revert');
				}
			}
		});
	});

	$(window).load(function() {
		$(window).trigger('scroll');
	});
}